import { ExtendedMap } from '@jeppesen-foreflight/jmkw-types';
import { TwcTime } from '../twc-time';

/**
 * Validates that a forecast timestamp is valid for a given timestamp
 */
export const isValidForecastTime = (
  ts: string,
  fts: string,
  validFtsList: string[]
): boolean => {
  if (!ts || !fts || !validFtsList || validFtsList.length === 0) return false;
  return validFtsList.includes(fts);
};

/**
 * Gets a valid forecast time for a timestamp
 * Returns the original fts if valid, first valid fts if available, or undefined
 */
export const getValidForecastTime = (
  ts: string,
  fts: string,
  validFtsList: string[]
): string | undefined => {
  if (!ts || !fts) return fts;
  if (!validFtsList || validFtsList.length === 0) return fts;

  if (validFtsList.includes(fts)) {
    return fts;
  }

  return validFtsList.length > 0 ? validFtsList[0] : undefined;
};

/**
 * Extracts valid forecast times from a time map
 */
export const extractForecastTimes = (
  timeMap: ExtendedMap<TwcTime>
): string[] => {
  if (!timeMap || timeMap.size === 0) return [];
  return [...timeMap.keys()];
};

/**
 * Validates that a time is valid for a given product
 */
export const isValidTimeForProduct = (
  time: string,
  validTimes: string[]
): boolean => {
  if (!time || !validTimes || validTimes.length === 0) return false;
  return validTimes.includes(time);
};

/**
 * Gets a valid time for a product
 * Returns the original time if valid, first valid time if available, or original time
 */
export const getValidTimeForProduct = (
  time: string,
  validTimes: string[]
): string => {
  if (!time || !validTimes || validTimes.length === 0) return time;

  if (validTimes.includes(time)) {
    return time;
  }

  return validTimes[0];
};

/**
 * Formats a cache key for ts-fts combinations
 */
export const formatTsFtsCacheKey = (ts: string): string => {
  return `ts_${ts}`;
};
